import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { registerStrapiUnauthorizedRedirect } from '../utils/strapiFetch';

/**
 * Registra history.push para redirección por 401 (SPA) en lugar de recarga completa.
 */
export default function SessionExpiredRedirect() {
    const history = useHistory();
    useEffect(() => {
        registerStrapiUnauthorizedRedirect((path) => history.push(path || '/login'));
        return () => registerStrapiUnauthorizedRedirect(null);
    }, [history]);
    return null;
}
